module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp2_3016.bb339d42.png";